export enum TourBannerType {
	INFORMATIVE = 'INFORMATIVE',
	NEW_FEATURE = 'NEW_FEATURE'
}

export const TOUR_BANNER_TYPE_OPTION: { [bannerType: string]: TourBannerTypeOption } = {
	INFORMATIVE: {
		icon: 'exclamation-triangle',
		headerColor: '#fcd015',
		contentColor: '#fff2bf'
	},
	NEW_FEATURE: {
		icon: 'lightbulb',
		headerColor: '#8f63bc',
		contentColor: '#e6d2fb'
	}
};

export interface TourBannerTypeOption {
	icon: string;
	headerColor: string;
	contentColor: string;
}
